if (!customElements.get("journal-article")) {
  class JournalArticle extends HTMLElement {
    connectedCallback() {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.initialize(), { once: true });
        return;
      }

      this.initialize();
    }

    initialize() {
      if (this.dataset.galleryEnhanced === "true") return;

      this.dataset.galleryEnhanced = "true";
      this.groupConsecutiveImages();
    }

    groupConsecutiveImages() {
      const content = this.querySelector("[data-article-content]");
      if (!content) return;

      let imageBlocks = [];

      const flushImageBlocks = () => {
        if (imageBlocks.length < 2) {
          imageBlocks = [];
          return;
        }

        const gallery = document.createElement("div");
        const countClass = imageBlocks.length <= 5 ? imageBlocks.length : "many";

        gallery.className = `journal-article__gallery journal-article__gallery--${countClass}`;
        imageBlocks[0].before(gallery);
        imageBlocks.forEach((block) => gallery.append(block));
        imageBlocks = [];
      };

      Array.from(content.children).forEach((element) => {
        if (this.isStandaloneImageBlock(element)) {
          imageBlocks.push(element);
          return;
        }

        flushImageBlocks();
      });

      flushImageBlocks();
    }

    isStandaloneImageBlock(element) {
      if (!(element instanceof HTMLElement)) return false;
      if (element.classList.contains("journal-article__gallery")) return false;
      if (element.querySelectorAll("img").length !== 1) return false;

      return element.textContent.trim() === "";
    }
  }

  customElements.define("journal-article", JournalArticle);
}
